import { render, staticRenderFns } from "./labourServices.vue?vue&type=template&id=14eed8c0&scoped=true&"
import script from "./labourServices.vue?vue&type=script&lang=js&"
export * from "./labourServices.vue?vue&type=script&lang=js&"
import style0 from "./labourServices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./labourServices.vue?vue&type=style&index=1&id=14eed8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eed8c0",
  null
  
)

export default component.exports